import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { tokens, Text, Icon } from '@hotjar/hotsauce';
import { AccordionSection } from '../PanelAccordion/AccordionSection';

const Benefits = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacer.x2};
`;

const Benefit = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${tokens.spacer.x1};
`;

export const BenefitsSection = (): JSX.Element => {
  const { t } = useTranslation('heatmaps');

  return (
    <AccordionSection
      title={
        <Text as="span" textType="subtitle2">
          {t('smart-panel.engagement-zones.help.benefits.title')}
        </Text>
      }
      headerCustomCss={css`
        padding-top: ${tokens.spacer.x2};
      `}
    >
      <Benefits>
        <Benefit>
          <Icon icon="check" />
          <Text as="span">{t('smart-panel.engagement-zones.help.benefits.benefit-1')}</Text>
        </Benefit>
        <Benefit>
          <Icon icon="check" />
          <Text as="span">{t('smart-panel.engagement-zones.help.benefits.benefit-2')}</Text>
        </Benefit>
      </Benefits>
    </AccordionSection>
  );
};
